/* Тест по алгебре — страница.
 *
 * Страница только рисует и собирает ответы: задание строит и проверяет сервер
 * (/api/algebra-test/*), ключ ответа сюда не приходит, пока тест не закончен.
 * Прогон живёт на сервере, здесь — только его номер и предъявительский ключ
 * (localStorage `alg_active`), поэтому «обновил страницу» и «вернулся завтра»
 * продолжают с того же задания.
 *
 * Формулы: во фразах — между $…$, отдельной строкой — блоки `tex`; рисует
 * KaTeX (vendor/katex, грузится тегом). Рисунки — данные `figure`, рисуются
 * здесь в SVG, без текста внутри картинки.
 *
 * Ссылка на результат (`?r=<прогон>&k=<ключ>`) открывает ГОТОВЫЙ результат
 * тому, с кем им поделились (родитель, репетитор): только просмотр — ни
 * история, ни «Мой прогресс», ни незаконченный тест этого браузера её не
 * касаются.
 */
(function () {
    'use strict';

    var CFG = window.__ALG || {};
    var T = CFG.T || {};
    var LOCALE = CFG.locale || document.documentElement.lang || 'ru';
    var SLUG = 'algebra-test';
    var ACTIVE_KEY = 'alg_active';
    var HISTORY_KEY = 'alg_history';
    var HISTORY_MAX = 30;
    // «Было → стало» у перепроверки: статусы тем в прогоне, из которого её
    // запустили, — по номеру нового прогона (на этом устройстве).
    var FOCUS_KEY = 'alg_focus';
    var MONTH_MS = 28 * 86400000;

    var panel = document.getElementById('algPanel');
    var wrap = document.getElementById('algWrap');
    if (!panel) return;
    // Первый экран рисует СЕРВЕР (#algStart в блейде), чтобы он был виден с
    // первой отрисовкой: этот отложенный скрипт просыпается только после разбора
    // всей страницы (замер 08.10.2026 на соседнем тесте: 7.8 с на 4G и среднем
    // телефоне против 2.3 с у текста). Узел остаётся тем же: renderStart() только
    // переключает его состояние, а нажатие, сделанное раньше скрипта, передаёт
    // window.__earlyAction (layout head) — см. claimEarly().
    var startNode = document.getElementById('algStart');

    var S = {
        screen: null,        // null до первой отрисовки: стадия 'start' отмечается при входе на экран
        run: null,           // {id, token}
        item: null,
        mode: null,          // режим прогона на сервере (после «продолжить до полной» — full)
        shownAt: 0,
        choice: null,
        busy: false,
        level: null,
        goal: 'gaps',
        mode0: 'full',       // выбор формата на старте
        needGrade: false,
        cls: null,           // информация о классе по ссылке учителя
        clsCode: null,
        result: null,
        shared: false,       // открыт чужой результат по ссылке
        firstShown: false,   // стадия «question» уже отмечена для этого прогона
        opened: {},          // какие разделы результата уже открывали (телеметрия — один раз)
        histMerged: false,
        pr: null,            // тренировка по теме: {topic, step, steps, n, ok, streak, …}
        pendingFocus: null,  // контекст перепроверки до ответа сервера о новом прогоне
        remind: undefined,   // напоминание вошедшего: {at, email} | null (undefined — не спрашивали)
        remindBusy: false,
        monthShown: false
    };

    /* ── мелочи ─────────────────────────────────────────────────────── */

    function t(key, params) {
        var s = T[key];
        if (s == null) s = key;
        if (params) {
            var keys = Object.keys(params).sort(function (a, b) { return b.length - a.length; });
            keys.forEach(function (k) { s = s.split(':' + k).join(String(params[k])); });
        }
        return s;
    }
    function esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }
    function store(key, val) { try { if (val == null) localStorage.removeItem(key); else localStorage.setItem(key, JSON.stringify(val)); } catch (_) {} }
    function load(key) { try { var v = localStorage.getItem(key); return v ? JSON.parse(v) : null; } catch (_) { return null; } }
    function stage(name, meta) { try { if (window.__stage) window.__stage(name, meta || {}); } catch (_) {} }
    function feat(f, p) { try { if (window.__aeFeature) window.__aeFeature(f, p || {}); } catch (_) {} }
    function diag(issue, p) { try { if (window.__aeDiagnostic) window.__aeDiagnostic(Object.assign({ issue: issue }, p || {})); } catch (_) {} }
    function announce(msg) { try { if (window.__announce) window.__announce(msg); } catch (_) {} }
    function toast(msg, type) { if (window.__toast) window.__toast(msg, type || 'error'); }
    function isTouch() { return window.matchMedia && matchMedia('(pointer: coarse)').matches; }
    function csrf() { var m = document.querySelector('meta[name="csrf-token"]'); return m ? m.content : ''; }

    function api(method, url, body) {
        var ready = (method === 'POST' && typeof window.__csrfReady === 'function') ? window.__csrfReady() : Promise.resolve(null);
        return ready.then(function () {
            var opts = {
                method: method,
                credentials: 'same-origin',
                headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
            };
            if (method === 'POST') {
                opts.headers['Content-Type'] = 'application/json';
                opts.headers['X-CSRF-TOKEN'] = csrf();
                opts.body = JSON.stringify(body || {});
            }
            return fetch(url, opts).then(function (r) {
                return r.json().catch(function () { return {}; }).then(function (j) {
                    j = j || {};
                    j.__status = r.status;
                    return j;
                });
            });
        });
    }

    /** Отказ сервера или сети — человеку фраза, нам причина (операция и код). */
    function apiFail(op, j) {
        diag('api_error', { op: op, status: j && j.__status ? j.__status : 0, error: j && j.error ? String(j.error).slice(0, 40) : 'network' });
    }

    /**
     * Экран меняется на месте: стартовый длиннее задания, результат длиннее
     * всего. После смены начало экрана может оказаться над окном или под
     * закреплённой шапкой сайта — на телефоне так пряталось условие задачи, и
     * человек видел одно поле ответа. Правило сайта — только 'nearest'
     * (прокрутка, лишь если элемент за краем, и ровно настолько); отступ под
     * шапку — scroll-margin, измеренный по ЖИВОЙ шапке: на экране 320 px она
     * в две строки, в альбомной ориентации её нет вовсе.
     */
    function reveal(el) {
        if (!el || !el.scrollIntoView) return;
        var off = 16;
        var hdr = document.querySelector('.header');
        if (hdr) {
            var pos = getComputedStyle(hdr).position;
            if (pos === 'fixed' || pos === 'sticky') off += Math.max(0, hdr.getBoundingClientRect().bottom);
        }
        el.style.scrollMarginTop = Math.round(off) + 'px';
        try { el.scrollIntoView({ block: 'nearest' }); } catch (_) {}
    }

    /* ── формулы ────────────────────────────────────────────────────── */

    function texHtml(tex, display) {
        if (window.katex && window.katex.renderToString) {
            try {
                return window.katex.renderToString(tex, { throwOnError: false, displayMode: !!display, strict: 'ignore' });
            } catch (_) { /* упадём на код ниже */ }
        }
        return '<code class="alg-tex-raw">' + esc(tex) + '</code>';
    }

    /** Фраза с формулами между $…$ → HTML (текст экранируется). */
    function richText(s) {
        var parts = String(s == null ? '' : s).split('$');
        var out = '';
        for (var i = 0; i < parts.length; i++) {
            out += i % 2 === 1 ? texHtml(parts[i], false) : esc(parts[i]);
        }
        return out;
    }

    function blocksHtml(blocks) {
        return (blocks || []).map(function (b) {
            if (b.tex != null) return '<div class="alg-tex">' + texHtml(b.tex, true) + '</div>';
            return '<p class="alg-text">' + richText(b.text) + '</p>';
        }).join('');
    }

    /* ── рисунок: график на клетчатой сетке ─────────────────────────── */

    function evalPoly(c, x) {
        var v = 0;
        for (var i = 0; i < c.length; i++) v = v * x + c[i];
        return v;
    }

    function figureSvg(fig) {
        if (!fig || fig.kind !== 'plot') return '';
        var x0 = fig.x[0], x1 = fig.x[1], y0 = fig.y[0], y1 = fig.y[1];
        var W = 320, H = 320, pad = 8;
        var sx = (W - 2 * pad) / (x1 - x0), sy = (H - 2 * pad) / (y1 - y0);
        function X(x) { return pad + (x - x0) * sx; }
        function Y(y) { return H - pad - (y - y0) * sy; }
        var g = '';
        for (var gx = Math.ceil(x0); gx <= x1; gx++) g += '<line x1="' + X(gx) + '" y1="' + Y(y0) + '" x2="' + X(gx) + '" y2="' + Y(y1) + '" class="alg-grid"/>';
        for (var gy = Math.ceil(y0); gy <= y1; gy++) g += '<line x1="' + X(x0) + '" y1="' + Y(gy) + '" x2="' + X(x1) + '" y2="' + Y(gy) + '" class="alg-grid"/>';
        // оси со стрелками
        g += '<line x1="' + X(x0) + '" y1="' + Y(0) + '" x2="' + (X(x1) - 2) + '" y2="' + Y(0) + '" class="alg-axis" marker-end="url(#algArrow)"/>';
        g += '<line x1="' + X(0) + '" y1="' + Y(y0) + '" x2="' + X(0) + '" y2="' + (Y(y1) + 2) + '" class="alg-axis" marker-end="url(#algArrow)"/>';
        g += '<text x="' + (X(x1) - 10) + '" y="' + (Y(0) - 6) + '" class="alg-axlbl">x</text>';
        g += '<text x="' + (X(0) + 6) + '" y="' + (Y(y1) + 12) + '" class="alg-axlbl">y</text>';
        g += '<text x="' + (X(0) - 10) + '" y="' + (Y(0) + 13) + '" class="alg-axlbl">0</text>';
        g += '<text x="' + (X(1) - 3) + '" y="' + (Y(0) + 13) + '" class="alg-axlbl">1</text>';
        g += '<text x="' + (X(0) - 10) + '" y="' + (Y(1) + 4) + '" class="alg-axlbl">1</text>';
        (fig.curves || []).forEach(function (c) {
            var segs = [], cur = [];
            function push(x, y) {
                if (!isFinite(y) || y < y0 - 1 || y > y1 + 1) { if (cur.length > 1) segs.push(cur); cur = []; return; }
                cur.push(X(x).toFixed(1) + ',' + Y(Math.max(y0 - 0.5, Math.min(y1 + 0.5, y))).toFixed(1));
            }
            if (c.fn === 'pts') {
                c.p.forEach(function (p) { cur.push(X(p[0]).toFixed(1) + ',' + Y(p[1]).toFixed(1)); });
            } else {
                var step = (x1 - x0) / 400;
                for (var x = x0; x <= x1 + 1e-9; x += step) {
                    var y;
                    if (c.fn === 'poly') y = evalPoly(c.c, x);
                    else if (c.fn === 'hyper') { if (Math.abs(x) < step / 2) { push(x, NaN); continue; } y = c.k / x; }
                    push(x, y);
                }
            }
            if (cur.length > 1) segs.push(cur);
            segs.forEach(function (s) {
                g += '<polyline points="' + s.join(' ') + '" class="' + (c.style === 'tangent' ? 'alg-tangent' : 'alg-curve') + '"/>';
            });
        });
        (fig.marks || []).forEach(function (m) {
            g += '<circle cx="' + X(m[0]) + '" cy="' + Y(m[1]) + '" r="4" class="alg-mark"/>';
        });
        (fig.labels || []).forEach(function (l) {
            g += '<line x1="' + X(l.x) + '" y1="' + (Y(0) - 4) + '" x2="' + X(l.x) + '" y2="' + (Y(0) + 4) + '" class="alg-axis"/>';
            g += '<text x="' + (X(l.x) - 7) + '" y="' + (Y(0) + 15) + '" class="alg-axlbl alg-axlbl-b">' + esc(l.t) + '</text>';
        });
        return '<svg class="alg-fig" viewBox="0 0 ' + W + ' ' + H + '" role="img" aria-label="' + esc(t('figure_alt')) + '">'
            + '<defs><marker id="algArrow" viewBox="0 0 8 8" refX="7" refY="4" markerWidth="7" markerHeight="7" orient="auto"><path d="M0,0 L8,4 L0,8 z" class="alg-arrow"/></marker></defs>'
            + g + '</svg>';
    }

    /* ── экраны ─────────────────────────────────────────────────────── */

    /** Смена экрана: карточка разбора уезжает домой, отметка «будет не первый
     *  экран» (data-boot, инлайн-проверка в блейде) снимается. Возвращает прежний экран. */
    function leaveScreen(screen) {
        // Карточка разбора живёт в панели только на экране результата: перед
        // перерисовкой она уезжает домой, иначе innerHTML уничтожил бы её.
        if (window.AlgReport && window.AlgReport.unmount) { try { window.AlgReport.unmount(); } catch (_) {} }
        var prev = S.screen;
        S.screen = screen;
        panel.removeAttribute('data-boot');
        wrap.setAttribute('data-phase', screen);
        return prev;
    }

    function render(html, screen) {
        var prev = leaveScreen(screen);
        panel.innerHTML = html;
        return prev;
    }

    function gradeLabel(level) { return t('grades.l' + level); }

    /**
     * Первый экран — узел #algStart из блейда (одна разметка на сервер и скрипт).
     * Здесь он только показывается и переключается: выбранный класс, цели для
     * этого класса, формат, «продолжить незаконченный», баннер «прошёл месяц»,
     * история попыток этого устройства. Страница из кэша старше блейда узла не
     * имеет — тогда честное «не удалось загрузить», а не вторая копия разметки.
     */
    function renderStart(opts) {
        opts = opts || {};
        if (!startNode) {
            render('<div class="alg-card alg-center">' + esc(t('load_error')) + '</div>', 'start');
            return;
        }
        var active = load(ACTIVE_KEY);
        var resumable = !!(active && active.run);
        var month = monthSinceLast();
        var prev = leaveScreen('start');
        if (panel.firstElementChild !== startNode || panel.children.length !== 1) {
            panel.textContent = '';
            panel.appendChild(startNode);
        }
        syncStart(resumable, month);
        if (prev !== 'start') {
            stage('start');
            if (resumable) feat('resume_offered', {});
        }
        if (month && !resumable && !S.monthShown) {
            S.monthShown = true;
            feat('month_banner', { days: Math.round(month / 86400000) });
        }
        if (opts.focus) {
            var f = panel.querySelector(opts.focus);
            if (f) { try { f.focus({ preventScroll: true }); } catch (_) {} }
        }
        if (opts.reveal) reveal(panel.querySelector('.alg-card'));
    }

    function setRadio(b, on) {
        b.classList.toggle('on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
    }

    /** Состояние S → узел первого экрана. */
    function syncStart(resumable, month) {
        var q = function (sel) { return startNode.querySelector(sel); };
        var m = q('#algMonth');
        if (m) m.hidden = !(month && !resumable);
        var r = q('#algResume');
        if (r) r.hidden = !resumable;
        startNode.querySelectorAll('[data-level]').forEach(function (b) { setRadio(b, S.level === +b.getAttribute('data-level')); });
        var chips = q('.alg-chips');
        if (chips) chips.classList.toggle('need', !!S.needGrade);
        // Подсказка «сначала класс» — свежим элементом на каждый показ: role=alert
        // озвучивается, когда появляется, а не когда снимается hidden.
        var need = q('.alg-need');
        if (need) need.parentNode.removeChild(need);
        if (chips && S.needGrade && S.level == null) chips.insertAdjacentHTML('afterend', '<div class="alg-need" role="alert">' + esc(t('start_need_grade')) + '</div>');
        // Цели: «пробелы» всегда, ОГЭ — 8–9 класс, ЕГЭ — с 10-го; шаг виден, когда выбирать есть из чего.
        var shown = 0;
        startNode.querySelectorAll('[data-goal]').forEach(function (b) {
            var g = b.getAttribute('data-goal');
            var vis = g === 'gaps' || (S.level != null && (g === 'oge' ? S.level >= 8 && S.level <= 9 : S.level >= 10));
            b.hidden = !vis;
            if (vis) shown++;
            setRadio(b, S.goal === g);
        });
        var gs = q('#algStepGoal');
        if (gs) gs.hidden = shown < 2;
        startNode.querySelectorAll('[data-mode]').forEach(function (b) { setRadio(b, S.mode0 === b.getAttribute('data-mode')); });
        var slot = q('#algHistorySlot');
        if (slot) slot.innerHTML = historyHtml();
    }

    /**
     * Нажатия на первом экране, сделанные раньше этого скрипта, хранит
     * window.__earlyAction — по области на класс, формат и остальное («Начать»,
     * тема тренировки), так что «8 класс → Начать» до скрипта доходит целиком.
     * `replay` — только когда boot() показал первый экран и продолжать нечего:
     * результат по ссылке, класс и незаконченный тест нажатие отбрасывают.
     */
    function claimEarly(replay) {
        if (!window.__earlyAction) return;
        var fn = replay ? function (a, el) { if (el && panel.contains(el)) press(el); } : null;
        [SLUG + '-grade', SLUG + '-mode', SLUG].forEach(function (k) { window.__earlyAction.claim(k, fn); });
    }

    function historyList() {
        return (load(HISTORY_KEY) || []).filter(function (x) { return x && x.run; });
    }

    function historyHtml() {
        var h = historyList();
        if (!h.length) return '';
        var title = window.__AUTH_USER ? t('history_title_account') : t('history_title');
        var html = '<details class="alg-history"><summary class="alg-sum">' + esc(title) + ' (' + h.length + ')</summary><ul>';
        h.slice(0, 10).forEach(function (r) {
            var d = new Date(r.at);
            var date = isNaN(d) ? '' : d.toLocaleDateString(LOCALE);
            // Перепроверка — про несколько тем, а не про программу: без балла и уровня.
            var what = r.mode === 'focus'
                ? t('history_focus', { m: r.mastered, n: r.scope })
                : (r.grade ? t('history_level', { grade: gradeLabel(Math.min(r.grade, 11)) }) : t('res_level_below_short'))
                    + ' · ' + t('history_mastered', { m: r.mastered, n: r.scope });
            html += '<li><button type="button" class="alg-hist" data-act="open-history" data-run="' + r.run + '">'
                + '<span>' + esc(date) + ' · ' + esc(what) + '</span>' + (r.score && r.mode !== 'focus' ? '<b>' + r.score + '</b>' : '') + '</button></li>';
        });
        html += '</ul></details>';
        return html;
    }

    /** Сколько прошло с последней полной попытки, если это уже месяц; иначе 0. */
    function monthSinceLast() {
        var last = historyList().filter(function (x) { return x.mode !== 'focus' && x.at; })[0];
        if (!last) return 0;
        var ago = Date.now() - last.at;
        return ago >= MONTH_MS ? ago : 0;
    }

    /**
     * История вошедшего — ещё и с сервера: попытки с другого устройства или
     * из другого браузера. Без этого «Прошлые попытки» у вошедшего были бы
     * только этого браузера, хотя сервер их хранит (эндпоинт стоял без
     * единого вызова).
     */
    function mergeServerHistory() {
        if (S.histMerged || !window.__AUTH_USER) return;
        S.histMerged = true;
        api('GET', '/api/algebra-test/history').then(function (j) {
            if (!j.ok || !Array.isArray(j.runs)) return;
            var h = historyList();
            var have = {};
            h.forEach(function (x) { have[x.run] = 1; });
            var added = 0;
            j.runs.forEach(function (r) {
                if (!r || have[r.run]) return;
                h.push({ run: r.run, token: r.token, at: Date.parse(r.at) || 0, score: r.score, grade: r.grade, mastered: r.mastered, scope: r.scope, level: r.level, goal: r.goal, mode: r.mode, acct: 1 });
                added++;
            });
            if (!added) return;
            h.sort(function (a, b) { return (b.at || 0) - (a.at || 0); });
            store(HISTORY_KEY, h.slice(0, HISTORY_MAX));
            var slot = document.getElementById('algHistorySlot');
            // Полностью перерисовать нельзя: человек мог уже выбрать класс.
            // Баннер «прошёл месяц» мог появиться только теперь — его ставит
            // следующий показ старта, а список попыток — сразу.
            if (slot && S.screen === 'start') slot.innerHTML = historyHtml();
        }).catch(function () {});
    }

    function renderClassJoin() {
        var c = S.cls;
        var html = '<div class="alg-card">';
        if (!c || !c.ok) {
            var err = (c && c.error) || 'class_unknown';
            html += '<div class="alg-eyebrow">' + esc(t('class_eyebrow')) + '</div><p class="alg-warn">' + esc(t(err)) + '</p>'
                + '<button type="button" class="alg-btn ghost" data-act="solo">' + esc(t('class_solo')) + '</button></div>';
            render(html, 'class');
            reveal(panel.querySelector('.alg-card'));
            return;
        }
        html += '<div class="alg-eyebrow">' + esc(t('class_eyebrow')) + '</div>';
        html += '<h2 class="alg-h">' + esc(c.title) + '</h2>';
        html += '<p class="alg-lead">' + esc(t('class_desc', { grade: gradeLabel(c.level), mode: t('mode_' + c.mode) })) + '</p>';
        if (!c.open) {
            html += '<p class="alg-warn">' + esc(t('class_closed')) + '</p></div>';
            render(html, 'class');
            reveal(panel.querySelector('.alg-card'));
            return;
        }
        if (c.full) html += '<p class="alg-warn">' + esc(t('class_full')) + '</p>';
        html += '<label class="alg-lbl" for="algName">' + esc(t('class_name_label')) + '</label>'
            + '<input id="algName" class="alg-in" maxlength="40" autocomplete="name" enterkeyhint="go" value="' + esc(load('alg_student_name') || '') + '">'
            + '<div class="alg-fine">' + esc(t('class_name_hint')) + '</div>'
            + '<button type="button" class="alg-btn alg-go" data-act="class-start">' + esc(t('btn_start')) + '</button>'
            + '<ul class="alg-notes"><li>' + esc(t('start_note_tools')) + '</li><li>' + esc(t('start_note_honest')) + '</li></ul></div>';
        var prev = render(html, 'class');
        reveal(panel.querySelector('.alg-card'));
        if (prev !== 'class') stage('class_join');
    }

    /**
     * Условие, рисунок и поле ответа — одинаковые у задания теста и у задания
     * тренировки. `done` — ответ уже проверен (тренировка): поле только для
     * чтения, варианты выключены, выбранный и верный подсвечены.
     *
     * @param done {raw, choice, right}|null
     */
    function itemBodyHtml(it, done) {
        var html = '<div class="alg-stem" id="algStem">' + blocksHtml(it.stem) + '</div>';
        if (it.figure) html += '<div class="alg-figwrap">' + figureSvg(it.figure) + '</div>';
        if (it.format === 'choice') {
            var rightIdx = done && done.right != null ? it.choices.indexOf(done.right) : -1;
            html += '<div class="alg-opts" data-answer role="radiogroup" aria-label="' + esc(t('choice_hint')) + '">';
            it.choices.forEach(function (c, i) {
                var on = done && done.choice === i;
                var cls = 'alg-opt' + (on ? ' on' : '') + (done && i === rightIdx ? ' right' : '') + (on && i !== rightIdx && rightIdx >= 0 ? ' wrong' : '');
                html += '<button type="button" class="' + cls + '" role="radio" aria-checked="' + (on ? 'true' : 'false') + '" data-choice="' + i + '"' + (done ? ' disabled' : '') + '><span class="alg-kbd">' + (i + 1) + '</span><span>' + texHtml(c, false) + '</span></button>';
            });
            html += '</div>';
        } else {
            html += '<div class="alg-inrow"><input id="algAns" class="alg-in alg-ans" type="text" inputmode="' + (it.format === 'set' ? 'text' : 'decimal') + '" autocomplete="off" autocapitalize="off" spellcheck="false" enterkeyhint="done" aria-label="' + esc(t('answer_label')) + '" aria-describedby="algErr" placeholder="' + esc(t(it.format === 'set' ? 'answer_placeholder_set' : 'answer_placeholder')) + '"'
                + (done ? ' readonly value="' + esc(done.raw || '') + '"' : '') + '></div>';
            if (!done) {
                html += '<div class="alg-keys" role="group" aria-label="' + esc(t('keys_label')) + '">'
                    + '<button type="button" class="alg-key" data-key="-" aria-label="' + esc(t('key_minus')) + '">−</button>'
                    + '<button type="button" class="alg-key" data-key="/" aria-label="' + esc(t('key_frac')) + '">/</button>'
                    + '<button type="button" class="alg-key" data-key="' + esc(CFG.decimalSep || ',') + '" aria-label="' + esc(t('key_decimal')) + '">' + esc(CFG.decimalSep || ',') + '</button>'
                    + (it.format === 'set' ? '<button type="button" class="alg-key" data-key=";" aria-label="' + esc(t('key_semicolon')) + '">;</button><button type="button" class="alg-key alg-key-wide" data-key="∅">' + esc(t('key_empty')) + '</button>' : '')
                    + '</div>';
            }
            html += '<div class="alg-inerr" id="algErr" role="alert" hidden></div>';
        }
        if (it.hint && !done) html += '<div class="alg-hint">' + richText(it.hint) + '</div>';
        return html;
    }

    var MILESTONES = { 5: 1, 10: 1, 15: 1, 20: 1, 25: 1, 30: 1 };

    function renderQuestion() {
        var it = S.item;
        S.choice = null;
        // Фокус был в панели (клавиатура) — после перерисовки он не должен
        // улетать в начало документа: иначе Tab через всю шапку на КАЖДОМ задании.
        var ae = document.activeElement;
        var kbd = !!(ae && ae !== document.body && panel.contains(ae));
        var html = '<div class="alg-card alg-q" data-answer-scope>';
        html += '<div class="alg-qtop"><span class="alg-qn">' + esc(t('q_progress', { n: it.n, m: it.max })) + '</span>';
        if (it.can_finish) html += '<button type="button" class="alg-finish" data-act="finish">' + esc(t('btn_finish_early')) + '</button>';
        html += '</div><div class="alg-prog" aria-hidden="true"><div class="alg-prog-f" style="width:' + Math.round(it.progress * 100) + '%"></div></div>';
        html += itemBodyHtml(it, null);
        html += '<div class="alg-actions alg-qa" data-answer>'
            + '<button type="button" class="alg-btn" data-act="answer">' + esc(t('btn_answer')) + '</button>'
            + '<button type="button" class="alg-btn ghost" data-act="skip">' + esc(t('btn_dont_know')) + '</button></div>';
        html += '</div>';
        render(html, 'question');
        reveal(panel.querySelector('.alg-qtop'));
        S.shownAt = performance.now();
        // Воронка прохождения: первое задание прогона и вехи по пути — по
        // последней из них видно, на каком задании бросают.
        if (!S.firstShown) {
            S.firstShown = true;
            stage('question', { mode: S.mode || S.mode0, n: it.n, resumed: it.n > 1 ? 1 : 0 });
        } else if (MILESTONES[it.n]) {
            stage('q' + it.n, { mode: S.mode || S.mode0 });
        }
        var inp = document.getElementById('algAns');
        if (inp && !isTouch()) { try { inp.focus({ preventScroll: true }); } catch (_) {} }
        else if (!inp && kbd) {
            var first = panel.querySelector('.alg-opt');
            if (first) { try { first.focus({ preventScroll: true }); } catch (_) {} }
        }
        announce(t('q_progress', { n: it.n, m: it.max }));
    }

    function renderComputing(msg) {
        render('<div class="alg-card alg-center"><div class="alg-spin"></div><p class="alg-lead">' + esc(msg || t('computing')) + '</p></div>', 'computing');
        reveal(panel.querySelector('.alg-card'));
    }

    /* ── действия ───────────────────────────────────────────────────── */

    function startRun(extra) {
        if (S.busy) return;
        S.busy = true;
        S.firstShown = false;
        S.mode = null;
        renderComputing(t('starting'));
        var body = Object.assign({ locale: LOCALE, device: isTouch() ? 'm' : 'd' }, extra);
        api('POST', '/api/algebra-test/start', body).then(function (j) {
            S.busy = false;
            if (!j.ok) {
                apiFail('start', j);
                if (S.clsCode) {
                    if (j.error === 'class_full' || j.error === 'name_required') {
                        S.cls = Object.assign({}, S.lastClassInfo || {}, { ok: true });
                        toast(t(j.error));
                    } else {
                        S.cls = { ok: false, error: j.error || 'class_unknown' };
                    }
                    renderClassJoin();
                    return;
                }
                S.pendingFocus = null;
                toast(t('net_error'));
                renderStart({ reveal: true });
                return;
            }
            S.run = { id: j.run, token: j.token };
            store(ACTIVE_KEY, { run: j.run, token: j.token, at: Date.now() });
            if (S.pendingFocus) {
                saveFocusCtx(j.run, S.pendingFocus);
                S.pendingFocus = null;
            }
            handleState(j);
        }).catch(function () {
            S.busy = false;
            S.pendingFocus = null;
            apiFail('start', null);
            toast(t('net_error'));
            if (S.clsCode) renderClassJoin(); else renderStart({ reveal: true });
        });
    }

    function handleState(j) {
        if (j.mode) S.mode = j.mode;
        if (Object.prototype.hasOwnProperty.call(j, 'remind')) S.remind = j.remind;
        if (j.status === 'active' && j.item) {
            S.item = j.item;
            renderQuestion();
        } else if (j.status === 'done' && j.data) {
            showResult(j.data);
        } else {
            if (!S.shared) store(ACTIVE_KEY, null);
            diag('bad_state', { status: j.status || '' });
            toast(t('net_error'));
            renderStart({ reveal: true });
        }
    }

    // Число, как его печатают на любом языке сайта: «2,5» и «2.5», «3/4»,
    // разряды «2,400» / «2.400» / «2 400» (какое прочтение верно — решает
    // сервер: Checker читает такую запись обоими способами).
    var VALID_NUM = /^[+\-−–]?(?:\d{1,3}(?:([.,   ])\d{3})(?:\1\d{3})*|\d+(?:[.,]\d+)?|[.,]\d+)(?:\s*\/\s*[+\-−–]?\d+(?:[.,]\d+)?)?\s*[°%]?$/;
    // «1/0» проходит форму числа, но числом не является: на сервере это
    // просто неверный ответ, а человек ошибся в записи, а не в решении.
    var ZERO_DEN = /\/\s*[+\-−–]?0+(?:[.,]0+)?\s*[°%]?$/;

    // Та же нормализация, что Checker::canon + Frac::normalize на сервере:
    // арабские и «персидские» цифры, «٫» в дроби, «؛» между корнями.
    function canonAnswer(raw) {
        return String(raw || '')
            .replace(/[٠-٩]/g, function (d) { return String(d.charCodeAt(0) - 0x660); })
            .replace(/[۰-۹]/g, function (d) { return String(d.charCodeAt(0) - 0x6F0); })
            .replace(/٫/g, '.').replace(/٬/g, ',')
            .replace(/[؛；]/g, ';').replace(/[،，]/g, ',')
            .replace(/\s+/g, ' ').trim();
    }

    // «d» цифры 0-9, «D» другие цифры, «a» латиница, «L» другие буквы, «p» знаки, «s» пробел
    function charClasses(raw) {
        var seen = {};
        String(raw).split('').forEach(function (ch) {
            var k = /[0-9]/.test(ch) ? 'd'
                : /[٠-٩۰-۹]/.test(ch) ? 'D'
                : /[a-z]/i.test(ch) ? 'a'
                : /\s/.test(ch) ? 's'
                : ch.toLowerCase() !== ch.toUpperCase() || /[ء-يٱ-ۓ가-힯㄰-㆏]/.test(ch) ? 'L'
                : 'p';
            seen[k] = 1;
        });
        return Object.keys(seen).sort().join('');
    }

    function isEmptyWord(s) {
        var w = s.toLowerCase().replace(/[.!。]+$/, '');
        return (CFG.emptyTokens || ['∅']).indexOf(w) !== -1;
    }

    function validNum(p) { return VALID_NUM.test(p) && !ZERO_DEN.test(p); }

    function validAnswer(format, raw) {
        var s = canonAnswer(raw);
        if (!s) return false;
        if (format === 'number') return validNum(s);
        if (isEmptyWord(s)) return true;
        return s.split(/\s*;\s*/).filter(Boolean).every(validNum)
            || /^[+\-−–]?\d+(\s*,\s*[+\-−–]?\d+)+$/.test(s);
    }

    function submit(skip) {
        if (S.busy || !S.item) return;
        var it = S.item;
        var body = { run: S.run.id, token: S.run.token, seq: it.seq, rt: Math.round(performance.now() - S.shownAt) };
        if (skip) {
            body.skip = true;
            feat('dont_know', { n: it.n });
        } else if (it.format === 'choice') {
            if (S.choice == null) { toast(t('choice_required'), 'warning'); return; }
            body.choice = S.choice;
        } else {
            var inp = document.getElementById('algAns');
            var raw = inp ? inp.value : '';
            if (!validAnswer(it.format, raw)) {
                var err = document.getElementById('algErr');
                if (err) { err.textContent = t(raw.trim() ? 'input_invalid' : 'input_empty'); err.hidden = false; }
                if (inp) inp.setAttribute('aria-invalid', 'true');
                // Что человек набрал, мы не шлём — только какие виды знаков там были:
                // так видно, если клавиатура какого-то языка пишет то, чего проверка не знает.
                if (raw.trim()) feat('input_invalid', { fmt: it.format, cls: charClasses(raw), zero: ZERO_DEN.test(canonAnswer(raw)) ? 1 : 0 });
                if (inp) inp.focus();
                return;
            }
            body.answer = raw.trim();
        }
        S.busy = true;
        panel.classList.add('alg-sending');
        sendAnswer(body, it, 0);
    }

    /**
     * Ответ идемпотентен: сервер сверяет номер задания, и повтор уже
     * записанного ответа возвращает текущее состояние, ничего не записывая.
     * Поэтому потерянный запрос (мобильная сеть, 502 на пересменке) один раз
     * повторяется сам — человек не должен нажимать «Ответить» дважды из-за
     * чужого сбоя. Отказ, который повтор не лечит, говорится словами.
     */
    function sendAnswer(body, it, attempt) {
        var done = function () { S.busy = false; panel.classList.remove('alg-sending'); };
        var again = function (why) {
            feat('answer_retry', { why: why });
            setTimeout(function () { sendAnswer(body, it, 1); }, 1200);
        };
        api('POST', '/api/algebra-test/answer', body).then(function (j) {
            if (!j.ok && j.__status >= 500 && !attempt) { again('http_' + j.__status); return; }
            done();
            if (!j.ok && j.__status !== 409) {
                apiFail('answer', j);
                if (j.__status === 404) { store(ACTIVE_KEY, null); renderStart({ reveal: true }); return; }
                toast(t('net_error'));
                return;
            }
            // Повтор, который застал свой же первый ответ записанным, — не
            // «другая вкладка»: об этом не говорим.
            if ((j.__status === 409 || j.dup) && !attempt) {
                // Этот ответ опоздал: задание уже отвечено — обычно тест открыт
                // ещё в одной вкладке. Молча перескочить значило бы потерять
                // ответ без единого слова.
                feat('stale_tab', { n: it.n, code: j.__status });
                toast(t('stale_tab'), 'info');
            }
            handleState(j);
        }).catch(function () {
            if (!attempt) { again('network'); return; }
            done();
            apiFail('answer', null);
            toast(t('net_error'));
        });
    }

    function finishEarly() {
        if (!S.run || S.busy) return;
        if (!window.confirm(t('finish_confirm'))) return;
        S.busy = true;
        feat('finish_early', { n: S.item ? S.item.n : null });
        renderComputing();
        api('POST', '/api/algebra-test/finish', { run: S.run.id, token: S.run.token }).then(function (j) {
            S.busy = false;
            if (!j.ok) { apiFail('finish', j); toast(t(j.error === 'too_early' ? 'finish_too_early' : 'net_error')); if (S.item) renderQuestion(); return; }
            handleState(j);
        }).catch(function () { S.busy = false; apiFail('finish', null); toast(t('net_error')); if (S.item) renderQuestion(); });
    }

    function resume(run, why) {
        S.run = { id: run.run, token: run.token };
        S.firstShown = false;
        renderComputing(t('resuming'));
        api('GET', '/api/algebra-test/state?run=' + encodeURIComponent(run.run) + '&token=' + encodeURIComponent(run.token)).then(function (j) {
            if (!j.ok) {
                apiFail('state', j);
                if (why === 'history') {
                    // Прогон удалён (срок хранения гостя) — убрать его из списка,
                    // иначе строка будет вести в никуда при каждом нажатии.
                    store(HISTORY_KEY, historyList().filter(function (x) { return x.run !== run.run; }));
                } else {
                    store(ACTIVE_KEY, null);
                }
                toast(t('history_gone'), 'warning');
                renderStart({ reveal: true });
                return;
            }
            if (why === 'resume') feat('resume', {});
            handleState(j);
        }).catch(function () { apiFail('state', null); toast(t('net_error')); renderStart({ reveal: true }); });
    }

    function upgrade() {
        if (!S.run || S.busy) return;
        S.busy = true;
        feat('upgrade', {});
        S.firstShown = true;   // это продолжение, а не новый прогон
        renderComputing(t('resuming'));
        api('POST', '/api/algebra-test/upgrade', { run: S.run.id, token: S.run.token }).then(function (j) {
            S.busy = false;
            if (!j.ok) { apiFail('upgrade', j); toast(t('net_error')); renderStart({ reveal: true }); return; }
            store(ACTIVE_KEY, { run: S.run.id, token: S.run.token, at: Date.now() });
            handleState(j);
        }).catch(function () { S.busy = false; apiFail('upgrade', null); toast(t('net_error')); renderStart({ reveal: true }); });
    }

    /* ── результат ──────────────────────────────────────────────────── */

    /** Запятая перечисления: у арабского своя «،». */
    function listSep() { return LOCALE === 'ar' ? '، ' : ', '; }

    function pct(x) { return Math.round((x || 0) * 100); }

    function statusBadge(st, tested, expected) {
        // Непройденная тема без «освоено» — не беда, а «впереди»: серым, не красным.
        var cls = st === 'yes' ? 'ok' : (!expected && st === 'no' ? 'ahead' : (st === 'no' ? 'bad' : 'mid'));
        var label = st === 'yes' ? t('status_yes') : (st === 'no' ? (expected ? t('status_no') : t('status_notyet')) : t('status_part'));
        return '<span class="alg-tst"><span class="alg-st ' + cls + '">' + esc(label) + '</span>'
            + (tested ? '' : '<span class="alg-pred" title="' + esc(t('status_pred_hint')) + '">' + esc(t('status_pred')) + '</span>') + '</span>';
    }

    function levelLine(r) {
        var g = r.level && r.level.grade;
        if (g == null || g < 6) return esc(t('res_level_below'));
        var s = t('res_level', { grade: gradeLabel(Math.min(g, 11)) });
        if (r.level.next_share >= 0.3 && g < 11) s += ' ' + t('res_level_partial', { next: gradeLabel(g + 1) });
        return esc(s);
    }

    /**
     * Пройденное и «впереди» — раздельно: в знаменателе «освоено 5 из 33»
     * у сентябрьского восьмиклассника стояли 14 тем, которых он ещё не
     * проходил, и типичный ученик читал это как провал.
     */
    /** [освоено, из скольких] — по пройденным темам, если они есть. */
    function masteredPair(r) {
        return r.studied && r.studied.total ? [r.studied.yes, r.studied.total] : [r.mastered, r.scope];
    }

    function masteredHtml(r) {
        var sd = r.studied;
        if (!sd || !sd.total) {
            return '<div class="alg-mastered">' + esc(t('res_mastered', { m: r.mastered, n: r.scope })) + '</div>'
                + '<div class="alg-meter" aria-hidden="true"><div style="width:' + Math.round(100 * r.mastered / Math.max(1, r.scope)) + '%"></div></div>';
        }
        var w = function (k) { return (100 * k / sd.total).toFixed(1); };
        var html = '<div class="alg-mastered">' + esc(t('res_studied', { n: sd.total })) + '</div>'
            + '<div class="alg-meter3" aria-hidden="true"><span class="ok" style="width:' + w(sd.yes) + '%"></span><span class="mid" style="width:' + w(sd.part) + '%"></span><span class="bad" style="width:' + w(sd.no) + '%"></span></div>'
            + '<div class="alg-legend3"><span class="ok">' + esc(t('res_studied_yes', { k: sd.yes })) + '</span><span class="mid">' + esc(t('res_studied_part', { k: sd.part })) + '</span><span class="bad">' + esc(t('res_studied_no', { k: sd.no })) + '</span></div>';
        var ah = r.ahead;
        if (ah && ah.total) html += '<div class="alg-ahead">' + esc(t(ah.yes ? 'res_ahead' : 'res_ahead_zero', { k: ah.yes, n: ah.total })) + '</div>';
        return html;
    }

    /**
     * Сравнение с прошлой попыткой: шкала одна для всех классов, и обещание
     * «сравнивайте баллы» (шаг 4 инструкции) без него оставалось на совести
     * человека. Разница меньше половины интервала оценки — честно «в пределах
     * погрешности», а не «рост на 10 баллов».
     */
    function prevHtml(r, prev) {
        if (!prev || prev.score == null || r.score == null) return '';
        var d = new Date(prev.at);
        var date = isNaN(d) ? '' : d.toLocaleDateString(LOCALE, { day: 'numeric', month: 'long' });
        var delta = r.score - prev.score;
        var noise = Math.max(25, ((r.score_hi || r.score) - (r.score_lo || r.score)) / 2);
        var key = Math.abs(delta) < noise ? 'res_prev_noise' : (delta > 0 ? 'res_prev_up' : 'res_prev_down');
        var sign = delta > 0 ? '+' : (delta < 0 ? '−' : '±');
        return '<div class="alg-prev ' + (key === 'res_prev_up' ? 'up' : (key === 'res_prev_down' ? 'down' : '')) + '">'
            + esc(t(key, { date: date, d: Math.abs(delta), delta: sign + Math.abs(delta), prev: prev.score })) + '</div>';
    }

    /** Разделы карты раскрыты только там, где есть пробелы, — и не больше двух:
     *  у слабого результата раскрытая целиком карта была пятью экранами на телефоне. */
    function openStrands(r, strandOf) {
        var gapsBy = {};
        Object.keys(r.topics).forEach(function (id) {
            var tp = r.topics[id];
            if (tp.exp && tp.st !== 'yes') gapsBy[strandOf[id]] = (gapsBy[strandOf[id]] || 0) + 1;
        });
        return Object.keys(gapsBy).sort(function (a, b) { return gapsBy[b] - gapsBy[a]; }).slice(0, 2);
    }

    /** Подпись статуса темы словами (для «было: …»). */
    function stLabel(st) {
        return st === 'yes' ? t('status_yes') : (st === 'no' ? t('status_no') : t('status_part'));
    }

    /** Тема как кнопка тренировки (свой результат) или просто метка (по ссылке). */
    function tagHtml(id, cls, from, own, names) {
        var nm = esc(names[id] || id);
        if (!own || !CFG.practiceUrl || !(CFG.topics || {})[id]) return '<span class="alg-tag ' + cls + '">' + nm + '</span>';
        return '<button type="button" class="alg-tag ' + cls + ' alg-tag-btn" data-act="practice" data-topic="' + esc(id) + '" data-from="' + from + '" title="' + esc(t('btn_practice')) + '">' + nm + '</button>';
    }

    /** Длина перепроверки — та же арифметика, что Selector::mode('focus') на сервере. */
    function focusLen(k) {
        var per = k <= 2 ? 4 : 3;
        return Math.min(24, Math.max(4, per * k));
    }
    function focusMin(n) { return Math.max(3, Math.round(n * 0.85)); }

    function statsHtml(r) {
        return '<div class="alg-stats"><div><b>' + r.correct + '</b><span>' + esc(t('stat_correct')) + '</span></div><div><b>' + r.n + '</b><span>' + esc(t('stat_items')) + '</span></div>'
            + (r.dur_s ? '<div><b>' + Math.max(1, Math.round(r.dur_s / 60)) + '</b><span>' + esc(t('stat_minutes')) + '</span></div>' : '') + '</div>';
    }

    function flagsHtml(r) {
        var early = (r.flags || []).indexOf('early') >= 0;
        var html = '';
        if (!r.valid) html += '<div class="alg-warn">' + esc(t('res_invalid')) + '</div>';
        else if (early) html += '<div class="alg-warn">' + esc(t('res_early')) + '</div>';
        if ((r.flags || []).indexOf('many_skips') >= 0) html += '<div class="alg-fine">' + esc(t('res_many_skips')) + '</div>';
        return html;
    }

    /** Шапка перепроверки: сколько тем из названных освоено сейчас. */
    function focusHeadHtml(data) {
        var r = data.result;
        var ids = focusIds(data);
        var c = { yes: 0, part: 0, no: 0 };
        ids.forEach(function (id) { c[r.topics[id].st] = (c[r.topics[id].st] || 0) + 1; });
        var n = ids.length;
        var w = function (k) { return (100 * k / Math.max(1, n)).toFixed(1); };
        var html = '<div class="alg-card alg-res">';
        html += '<div class="alg-eyebrow">' + esc(S.shared ? t('result_link_text') : t('focus_eyebrow')) + '</div>';
        html += '<div class="alg-level">' + esc(t('focus_title', { k: c.yes, n: n })) + '</div>';
        html += '<div class="alg-meter3" aria-hidden="true"><span class="ok" style="width:' + w(c.yes) + '%"></span><span class="mid" style="width:' + w(c.part) + '%"></span><span class="bad" style="width:' + w(c.no) + '%"></span></div>'
            + '<div class="alg-legend3"><span class="ok">' + esc(t('res_studied_yes', { k: c.yes })) + '</span><span class="mid">' + esc(t('res_studied_part', { k: c.part })) + '</span><span class="bad">' + esc(t('res_studied_no', { k: c.no })) + '</span></div>';
        if (n && c.yes === n) html += '<p class="alg-text alg-done">' + esc(t('focus_all')) + '</p>';
        else if (!c.yes) html += '<p class="alg-text">' + esc(t('focus_none')) + '</p>';
        html += statsHtml(r) + flagsHtml(r);
        html += '<p class="alg-fine alg-focus-note">' + esc(t('focus_note')) + '</p>';
        return html + '</div>';
    }

    function focusIds(data) {
        var r = data.result;
        return (data.profile.topics || Object.keys(r.topics)).filter(function (id) { return r.topics[id]; });
    }

    /** Темы перепроверки: статус сейчас, «было» (если запускали отсюда), тренировка. */
    function focusListHtml(data, own) {
        var r = data.result;
        var names = data.names || {};
        var ids = focusIds(data);
        var ctx = own && S.run ? focusCtx(S.run.id) : null;
        var html = '<div class="alg-card"><h3 class="alg-h3">' + esc(t('focus_list_title')) + '</h3><ul class="alg-flist">';
        ids.forEach(function (id) {
            var tp = r.topics[id];
            var was = ctx && ctx.before ? ctx.before[id] : null;
            html += '<li><div class="alg-fl-main"><span class="alg-tname">' + esc(names[id] || id) + '</span>'
                + (was ? '<span class="alg-was">' + esc(t('focus_was', { st: stLabel(was) })) + '</span>' : '') + '</div>'
                + '<div class="alg-fl-side">' + statusBadge(tp.st, tp.n > 0, true)
                + (own && tp.st !== 'yes' && (CFG.topics || {})[id] ? '<button type="button" class="alg-mini" data-act="practice" data-topic="' + esc(id) + '" data-from="focus">' + esc(t('btn_practice')) + '</button>' : '')
                + '</div></li>';
        });
        html += '</ul>';
        var rest = ids.filter(function (id) { return r.topics[id].st !== 'yes'; });
        if (own && !data.class) {
            html += '<div class="alg-actions alg-ra">';
            if (rest.length) html += '<button type="button" class="alg-btn" data-act="focus" data-from="rest" data-topics="' + esc(rest.join(',')) + '">' + esc(t('btn_focus_rest')) + '</button>';
            html += '<button type="button" class="alg-btn ghost" data-act="retake">' + esc(t('btn_full')) + '</button></div>';
        }
        return html + '</div>';
    }

    /** Пробелы, план и «можно идти дальше» — с дверями в тренировку и перепроверку. */
    function gapsCardHtml(data, own) {
        var r = data.result;
        var names = data.names || {};
        var html = '<div class="alg-card" id="algGaps"><h3 class="alg-h3">' + esc(t('gaps_title')) + '</h3>';
        if (r.gaps && r.gaps.length) {
            // Список длиннее восьми — это уже не список, а стена: первые восемь
            // (младшие классы вперёд), остальное — под раскрытием.
            var head = r.gaps.slice(0, 8), tail = r.gaps.slice(8);
            html += '<p class="alg-fine">' + esc(t('gaps_hint')) + '</p><div class="alg-tags">';
            head.forEach(function (id) { html += tagHtml(id, 'bad', 'gap', own, names); });
            html += '</div>';
            if (tail.length) {
                html += '<details class="alg-more" data-open="gaps_more"><summary class="alg-sum">' + esc(t('gaps_more', { n: tail.length })) + '</summary><div class="alg-tags">';
                tail.forEach(function (id) { html += tagHtml(id, 'bad', 'gap', own, names); });
                html += '</div></details>';
            }
            if (own && CFG.practiceUrl) html += '<p class="alg-fine alg-tap">' + esc(t('practice_tap_hint')) + '</p>';
            // Перепроверка — своя, не из класса: у ученика класса тест задаёт учитель.
            if (own && !data.class) {
                // Пробелы идут от младших классов — первые из них и есть основа.
                var ft = r.gaps.slice(0, CFG.focusMax || 8);
                var n = focusLen(ft.length);
                var hint = ft.length < r.gaps.length
                    ? t('focus_hint_first', { k: ft.length, n: n, min: focusMin(n) })
                    : t('focus_hint', { n: n, min: focusMin(n) });
                html += '<div class="alg-focus-cta"><button type="button" class="alg-btn" data-act="focus" data-from="gaps" data-topics="' + esc(ft.join(',')) + '">' + esc(t('btn_focus')) + '</button>'
                    + '<span class="alg-fine">' + esc(hint) + '</span></div>';
            }
        } else {
            html += '<p class="alg-text">' + esc(t('gaps_none')) + '</p>';
        }
        var next = r.next || [];
        if (next.length) {
            html += '<h3 class="alg-h3 alg-h3-next">' + esc(t('next_title')) + '</h3><ol class="alg-next">';
            next.forEach(function (n) {
                html += '<li><div class="alg-nrow"><div><b>' + esc(names[n.topic] || n.topic) + '</b>'
                    + (n.ready ? (n.base ? '' : ' <span class="alg-fine">' + esc(t('next_ready')) + '</span>')
                        : '<div class="alg-fine">' + esc(t('next_first', { list: n.missing.map(function (m) { return names[m] || m; }).join(listSep()) })) + '</div>')
                    + '</div>'
                    + (own && CFG.practiceUrl && (CFG.topics || {})[n.topic] ? '<button type="button" class="alg-mini" data-act="practice" data-topic="' + esc(n.topic) + '" data-from="next">' + esc(t('btn_practice')) + '</button>' : '')
                    + '</div></li>';
            });
            html += '</ol>';
        }
        // Сильному ученику «что учить» было пустым местом: всё, что тест
        // проверял, освоено. Дальше — следующие темы программы, для которых
        // основа уже есть (их тест не спрашивал — поэтому без статуса).
        var beyond = (r.beyond || []).filter(function (id) { return names[id]; });
        if (next.length < 3 && beyond.length) {
            html += '<h3 class="alg-h3 alg-h3-next">' + esc(t('beyond_title')) + '</h3><p class="alg-fine">' + esc(t('beyond_hint')) + '</p><div class="alg-tags">';
            beyond.forEach(function (id) { html += tagHtml(id, 'next', 'beyond', own, names); });
            html += '</div>';
        } else if (!next.length && !(r.gaps || []).length) {
            html += '<p class="alg-text alg-done">' + esc(t('all_done')) + '</p>';
        }
        return html + '</div>';
    }

    function examHtml(r, names) {
        if (!r.exam) return '';
        var ex = r.exam;
        var html = '<div class="alg-card"><h3 class="alg-h3">' + esc(t('exam_title', { exam: t('exam_' + ex.key) })) + '</h3>';
        html += '<p class="alg-text">' + esc(t('exam_part1', { c: ex.part1_covered, t: ex.part1_total, x: String(ex.part1_expected).replace('.', CFG.decimalSep || ',') })) + '</p><div class="alg-exam">';
        Object.keys(ex.tasks).forEach(function (n) {
            var task = ex.tasks[n];
            var p = task.p;
            var cls = p >= 0.7 ? 'ok' : (p >= 0.4 ? 'mid' : 'bad');
            html += '<div class="alg-exrow"><span class="alg-exn">' + esc(t('exam_task', { n: n })) + (task.part === 2 ? ' <em>' + esc(t('exam_part2')) + '</em>' : '') + '</span>'
                + '<span class="alg-exbar"><span class="' + cls + '" style="width:' + pct(p) + '%"></span></span><span class="alg-exp">' + pct(p) + '%</span>'
                + '<span class="alg-extopics">' + esc(task.topics.map(function (id) { return names[id] || id; }).join(listSep())) + '</span></div>';
        });
        html += '</div><p class="alg-fine">' + esc(t('exam_not_covered')) + '</p>';
        if (CFG.egeUrl && ex.key !== 'oge') html += '<a class="alg-link alg-exam-link" href="' + esc(CFG.egeUrl) + '" data-act="exam-calc">' + esc(t('exam_calc_link')) + '</a>';
        return html + '</div>';
    }

    function mapHtml(data) {
        var r = data.result;
        var names = data.names || {};
        var open = openStrands(r, data.strand_of || {});
        var html = '<div class="alg-card"><h3 class="alg-h3">' + esc(t('map_title')) + '</h3><p class="alg-fine">' + esc(t('map_hint')) + '</p>';
        Object.keys(r.strands).forEach(function (s) {
            var st = r.strands[s];
            var ids = Object.keys(r.topics).filter(function (id) { return data.strand_of[id] === s; });
            html += '<details class="alg-strand" data-open="map:' + esc(s) + '"' + (open.indexOf(s) >= 0 ? ' open' : '') + '><summary><span class="alg-caret" aria-hidden="true"></span><span class="alg-sname">' + esc(data.strand_names[s] || s) + '</span>'
                + '<span class="alg-sbar"><span style="width:' + pct(st.succ) + '%"></span></span><span class="alg-scount">' + esc(t('strand_line', { yes: st.yes, total: st.total })) + '</span></summary><ul>';
            ids.forEach(function (id) {
                var tp = r.topics[id];
                html += '<li><span class="alg-tname">' + esc(names[id] || id) + '</span>' + statusBadge(tp.st, tp.n > 0, tp.exp) + '</li>';
            });
            html += '</ul></details>';
        });
        return html + '</div>';
    }

    function bugsHtml(data) {
        if (!data.bugs || !data.bugs.length) return '';
        var html = '<div class="alg-card"><h3 class="alg-h3">' + esc(t('bugs_title')) + '</h3><p class="alg-fine">' + esc(t('bugs_hint')) + '</p><ul class="alg-bugs">';
        data.bugs.forEach(function (b) {
            html += '<li><b>' + richText(b.name) + '</b>' + (b.count > 1 ? ' <span class="alg-fine">×' + b.count + '</span>' : '') + '<div class="alg-text">' + richText(b.tip) + '</div></li>';
        });
        return html + '</ul></div>';
    }

    function reviewHtml(data) {
        var names = data.names || {};
        var html = '<div class="alg-card"><details class="alg-review" data-open="review"><summary class="alg-sum"><span>' + esc(t('review_title')) + ' <span class="alg-fine">' + esc(t('review_hint')) + '</span></span></summary><ol>';
        (data.review || []).forEach(function (rv) {
            var mark = rv.skipped ? 'skip' : (rv.correct ? 'ok' : 'bad');
            html += '<li class="alg-rv ' + mark + '"><div class="alg-rv-topic">' + esc(names[rv.topic] || rv.topic) + '</div>' + blocksHtml(rv.stem)
                + (rv.figure ? '<div class="alg-figwrap sm">' + figureSvg(rv.figure) + '</div>' : '')
                + '<div class="alg-rv-line">' + esc(t('review_your')) + ' ' + (rv.skipped ? esc(t('review_skipped')) : (rv.your ? texHtml(rv.your) : '—'))
                + ' · ' + esc(t('review_right')) + ' ' + texHtml(rv.right) + '</div>'
                + (rv.bug ? '<div class="alg-rv-bug">' + richText(rv.bug.name) + '</div>' : '') + '</li>';
        });
        return html + '</ol></details></div>';
    }

    function showResult(data, opts) {
        opts = opts || {};
        S.result = data;
        var r = data.result;
        var own = !S.shared;
        var focus = !!(data.profile && data.profile.mode === 'focus');
        var prev = null;
        // «Свежий» результат — впервые на этом устройстве или изменившийся
        // (быстрая проверка продолжена до полной). Повторный показ из истории —
        // не новое прохождение: ни tool_complete, ни второй точки в «Моём
        // прогрессе» (сценарием: открытие старой попытки писало её балл ещё раз).
        // Возврат из тренировки — вообще не показ: ничего не пишется.
        var fresh = false;
        if (own) {
            var h = historyList();
            var curId = S.run && S.run.id;
            var idx = -1;
            h.forEach(function (x, i) { if (x.run === curId) idx = i; });
            var existing = idx >= 0 ? h[idx] : null;
            // Сравнение — с полной попыткой ДО этой; перепроверка сравнивается
            // по темам («было → стало»), а не баллом.
            if (!focus) prev = (idx >= 0 ? h.slice(idx + 1) : h).filter(function (x) { return x.run !== curId && x.score != null && x.mode !== 'focus'; })[0] || null;
            if (!opts.back) {
                store(ACTIVE_KEY, null);
                fresh = !existing || existing.score !== r.score || (existing.mode != null && existing.mode !== data.profile.mode);
                // Прогон класса в историю устройства не пишется: в школьном
                // компьютерном классе за одним браузером сидят по очереди, и
                // следующий ученик открывал бы разбор предыдущего.
                if (fresh && !data.class) {
                    var mp = masteredPair(r);
                    var entry = { run: curId, token: S.run && S.run.token, at: Date.now(), score: r.score, grade: r.level && r.level.grade, mastered: mp[0], scope: mp[1], level: data.profile.level, goal: data.profile.goal, mode: data.profile.mode };
                    if (idx >= 0) h.splice(idx, 1);
                    h.unshift(entry);
                    store(HISTORY_KEY, h.slice(0, HISTORY_MAX));
                }
            }
        }
        var early = (r.flags || []).indexOf('early') >= 0;
        var html = '';
        if (S.shared) {
            html += '<div class="alg-banner">' + esc(t('shared_banner')) + '</div>';
        } else if (data.class) {
            html += '<div class="alg-banner ok">' + esc(t('class_sent', { title: data.class.title || '' })) + '</div>';
        }

        if (focus) {
            html += focusHeadHtml(data);
            html += focusListHtml(data, own);
            html += bugsHtml(data);
            html += reviewHtml(data);
        } else {
            html += '<div class="alg-card alg-res">';
            // По ссылке смотрит не тот, кто проходил: «Ваш результат» там неправда.
            html += '<div class="alg-eyebrow">' + esc(S.shared ? t('result_link_text') : t('res_eyebrow')) + '</div>';
            html += '<div class="alg-level">' + levelLine(r) + '</div>';
            html += masteredHtml(r);
            html += '<div class="alg-score">' + esc(t('res_score', { s: r.score, lo: r.score_lo, hi: r.score_hi })) + ' <span class="alg-fine">' + esc(t('res_score_hint')) + '</span></div>';
            if (own) html += prevHtml(r, prev);
            if (data.norm) html += '<div class="alg-norm">' + esc(t('res_norm', { p: data.norm.pct, n: data.norm.n })) + '</div>';
            html += statsHtml(r) + flagsHtml(r);
            html += '</div>';
            html += gapsCardHtml(data, own);
            html += examHtml(r, data.names || {});
            html += mapHtml(data);
            html += bugsHtml(data);
            // Документ (карточка перка переезжает сюда; в классе не продаём ничего)
            if (!data.class && CFG.report) html += '<div class="alg-card alg-cert-card"><div id="algCertSlot"></div></div>';
            html += reviewHtml(data);
            // Напоминание через месяц — своему результату полной диагностики.
            if (own && !data.class) html += remindCardHtml();
        }

        // Действия
        html += '<div class="alg-card alg-center"><div class="alg-actions alg-ra">';
        if (S.shared) {
            html += '<button type="button" class="alg-btn" data-act="try-self">' + esc(t('btn_try_self')) + '</button>';
        } else {
            if (data.profile.mode === 'quick' && !data.class) html += '<button type="button" class="alg-btn alg-ra-main" data-act="upgrade">' + esc(t('btn_upgrade')) + '</button>';
            if (!focus) html += '<button type="button" class="alg-btn ghost" data-act="retake">' + esc(t('btn_retake')) + '</button>';
            html += '<button type="button" class="alg-btn ghost" data-act="result-link">' + esc(t('btn_result_link')) + '</button>';
            if (!focus) html += '<button type="button" class="alg-btn ghost" data-act="share">' + esc(t('btn_share')) + '</button>';
        }
        html += '</div><div class="alg-linkbox" id="algLinkBox" hidden><input class="alg-in" id="algLinkIn" type="text" readonly aria-label="' + esc(t('btn_result_link')) + '"></div>';
        if (CFG.classUrl && !data.class && !S.shared && !focus) html += '<p class="alg-fine alg-teacher-after">' + esc(t('teacher_after')) + ' <a class="alg-link" href="' + esc(CFG.classUrl) + '" data-act="teacher" data-where="result">' + esc(t('teacher_btn')) + '</a></p>';
        html += '</div>';

        S.opened = {};
        render(html, 'result');
        if (opts.back && opts.topic) {
            // Вернулись из тренировки — к той теме, с которой ушли.
            var from = panel.querySelector('[data-act="practice"][data-topic="' + opts.topic + '"]');
            reveal(from || panel.querySelector('.alg-res'));
        } else {
            reveal(panel.querySelector(S.shared ? '.alg-banner' : '.alg-res'));
        }
        if (!focus) mountGate(data);
        var beyondN = (r.beyond || []).filter(function (id) { return (data.names || {})[id]; }).length;
        if (opts.back) {
            // ничего: это тот же показ
        } else if (own && !fresh) {
            feat('history_view', { valid: r.valid ? 1 : 0, focus: focus ? 1 : 0 });
        } else if (own) {
            var payload = {
                level: data.profile.level, goal: data.profile.goal, mode: data.profile.mode,
                n: r.n, correct: r.correct, grade: r.level ? r.level.grade : null,
                mastered: r.mastered, scope: r.scope, score: r.score, valid: !!r.valid, cls: !!data.class,
                early: early ? 1 : 0, gaps: (r.gaps || []).length, bugs: (data.bugs || []).length,
                beyond: beyondN, dur_s: r.dur_s || null, prev: prev ? r.score - prev.score : null
            };
            if (focus) {
                var fi = focusIds(data);
                var ctx = focusCtx(S.run && S.run.id);
                payload.focus = 1;
                payload.topics = fi.length;
                payload.closed = fi.filter(function (id) { return r.topics[id].st === 'yes'; }).length;
                payload.src = ctx ? ctx.src || null : null;
            }
            try { if (window.__aeToolComplete) window.__aeToolComplete(payload); } catch (_) {}
            // «Мой прогресс»: балл одной шкалы — только за честно пройденную
            // полную диагностику. Быстрые ответы, досрочный конец и
            // перепроверка (балл по слабым темам) дали бы на графике скачок,
            // которого не было.
            if (!focus && r.valid && !early && !data.class && r.score != null) {
                try {
                    if (window.__progress) window.__progress.record('algebra', {
                        value: r.score,
                        data: { g: r.level ? r.level.grade : null, m: masteredPair(r)[0], n: masteredPair(r)[1], lv: data.profile.level, mode: data.profile.mode }
                    });
                } catch (_) {}
            }
        } else {
            feat('shared_view', { ok: 1, valid: r.valid ? 1 : 0, focus: focus ? 1 : 0 });
        }
        if (!opts.back) announce(t(focus ? 'focus_eyebrow' : 'res_eyebrow'));
    }

    function mountGate(data) {
        if (data.class || !CFG.report || !window.AlgReport) return;
        try { window.AlgReport.mount(S.run, data); } catch (_) {}
    }

    /* ── перепроверка тем ───────────────────────────────────────────── */

    function focusCtx(runId) {
        if (!runId) return null;
        var all = load(FOCUS_KEY) || {};
        return all[runId] || null;
    }

    function saveFocusCtx(runId, ctx) {
        var all = load(FOCUS_KEY) || {};
        all[runId] = { before: ctx.before || {}, from: ctx.from || null, src: ctx.src || null, at: Date.now() };
        // Десять последних — «было» нужно только свежей перепроверке.
        var ids = Object.keys(all).sort(function (a, b) { return (all[b].at || 0) - (all[a].at || 0); });
        ids.slice(10).forEach(function (id) { delete all[id]; });
        store(FOCUS_KEY, all);
    }

    /** Уровень для короткого прогона: класс прошлого результата, выбранный или класс темы. */
    function levelFor(topics) {
        var lv = (S.result && S.result.profile && S.result.profile.level) || S.level;
        if (!lv) {
            lv = 5;
            topics.forEach(function (id) { var g = ((CFG.topics || {})[id] || {}).g; if (g > lv) lv = g; });
        }
        var levels = CFG.levels || [5, 6, 7, 8, 9, 10, 11, 12];
        return levels.indexOf(lv) >= 0 ? lv : levels[levels.length - 1];
    }

    function startFocus(topics, src) {
        topics = (topics || []).filter(function (id) { return (CFG.topics || {})[id]; }).slice(0, CFG.focusMax || 8);
        if (!topics.length || S.busy) return;
        var before = {};
        var r = S.result && S.result.result;
        if (r && r.topics) topics.forEach(function (id) { if (r.topics[id]) before[id] = r.topics[id].st; });
        var level = levelFor(topics);
        S.pendingFocus = { before: before, from: S.run ? S.run.id : null, src: src };
        feat('focus_start', { n: topics.length, from: src });
        S.clsCode = null;
        S.pr = null;
        startRun({ level: level, topics: topics });
    }

    /* ── тренировка по одной теме ───────────────────────────────────── */

    /**
     * Задание за заданием по одной теме, каждый ответ проверяется сразу и
     * показывается решение. Сложность — лестница по шаблонам темы: два верных
     * подряд — ступень вверх, промах — вниз. Сервер ничего не хранит: задание
     * возвращается на проверку подписанным билетом (PracticeTicket).
     */
    function openPractice(topic, from) {
        var tp = (CFG.topics || {})[topic];
        if (!tp || !CFG.practiceUrl) return;
        // Переход к теме-основе из тренировки возвращает туда же, откуда пришли.
        var back = S.pr ? S.pr.back : (S.screen === 'result' && S.result ? 'result' : 'start');
        S.pr = {
            topic: topic, name: tp.n, from: from,
            back: back,
            step: 0, steps: 1, n: 0, ok: 0, streak: 0, best: 0, top: 0, miss: 0,
            ticket: null, item: null, fb: null, fbNote: null, raw: null, choice: null, busy: false
        };
        stage('practice', { topic: topic, from: from });
        feat('practice_start', { topic: topic, from: from });
        renderComputing(t('practice_loading'));
        loadPracticeItem();
    }

    function loadPracticeItem() {
        var p = S.pr;
        if (!p || p.busy) return;
        p.busy = true;
        if (S.screen === 'practice') panel.classList.add('alg-sending');
        var url = CFG.practiceUrl + '?topic=' + encodeURIComponent(p.topic) + '&step=' + p.step + '&locale=' + encodeURIComponent(LOCALE);
        api('GET', url).then(function (j) {
            p.busy = false;
            panel.classList.remove('alg-sending');
            if (S.pr !== p) return;   // человек уже ушёл с тренировки
            if (!j.ok) {
                apiFail('practice', j);
                toast(t('net_error'));
                if (!p.item) leavePractice();
                return;
            }
            p.ticket = j.ticket;
            p.item = j.item;
            p.steps = j.steps || 1;
            p.step = j.step || 0;
            p.name = j.name || p.name;
            p.fb = null;
            p.raw = null;
            p.choice = null;
            renderPractice(true);
        }).catch(function () {
            p.busy = false;
            panel.classList.remove('alg-sending');
            apiFail('practice', null);
            toast(t('net_error'));
            if (S.pr === p && !p.item) leavePractice();
        });
    }

    function practiceStatsHtml(p) {
        var parts = [t('practice_stats', { k: p.ok, n: p.n })];
        if (p.streak > 1) parts.push(t('practice_streak', { s: p.streak }));
        if (p.steps > 1) parts.push(t('practice_level', { x: p.step + 1, y: p.steps }));
        return '<div class="alg-pr-stats">' + parts.map(esc).join(' · ') + '</div>';
    }

    function prereqHtml(topic) {
        var pre = (((CFG.topics || {})[topic] || {}).p || []).filter(function (id) { return (CFG.topics || {})[id]; });
        if (!pre.length) return '';
        var html = '<div class="alg-pr-pre"><p class="alg-fine">' + esc(t('practice_prereq')) + '</p><div class="alg-tags">';
        pre.forEach(function (id) {
            html += '<button type="button" class="alg-tag next alg-tag-btn" data-act="practice" data-topic="' + esc(id) + '" data-from="prereq">' + esc(CFG.topics[id].n) + '</button>';
        });
        return html + '</div></div>';
    }

    function renderPractice(fresh) {
        var p = S.pr;
        var it = p.item;
        S.choice = p.fb ? p.choice : null;
        var ae = document.activeElement;
        var kbd = !!(ae && ae !== document.body && panel.contains(ae));
        var html = '<div class="alg-card alg-q alg-pr">';
        html += '<div class="alg-qtop"><span class="alg-eyebrow">' + esc(t('practice_eyebrow')) + '</span>'
            + '<button type="button" class="alg-finish" data-act="practice-end">' + esc(t('btn_practice_end')) + '</button></div>';
        html += '<h2 class="alg-h alg-pr-h">' + esc(p.name) + '</h2>';
        html += practiceStatsHtml(p);
        html += itemBodyHtml(it, p.fb ? { raw: p.raw, choice: p.choice, right: p.fb.right } : null);
        if (!p.fb) {
            html += '<div class="alg-actions alg-qa" data-answer>'
                + '<button type="button" class="alg-btn" data-act="pr-check">' + esc(t('btn_check')) + '</button>'
                + '<button type="button" class="alg-btn ghost" data-act="pr-skip">' + esc(t('btn_solution')) + '</button></div>';
        } else {
            var fb = p.fb;
            var cls = fb.correct ? 'ok' : (fb.skipped ? 'skip' : 'bad');
            html += '<div class="alg-pfb ' + cls + '" id="algPfb" role="status">';
            html += '<div class="alg-pfb-h">' + esc(t(fb.correct ? 'practice_right' : (fb.skipped ? 'practice_shown' : 'practice_wrong'))) + '</div>';
            if (!fb.correct) {
                html += '<div class="alg-rv-line">' + (fb.your ? esc(t('review_your')) + ' ' + texHtml(fb.your) + ' · ' : '')
                    + esc(t('practice_answer')) + ' ' + texHtml(fb.right) + '</div>';
            }
            if (fb.bug) {
                html += '<div class="alg-pfb-bug"><b>' + esc(t('practice_bug')) + ' ' + richText(fb.bug.name) + '</b><div class="alg-text">' + richText(fb.bug.tip) + '</div></div>';
            }
            if (fb.solution && fb.solution.length) {
                html += '<details class="alg-sol" data-open="pr_solution"' + (fb.correct ? '' : ' open') + '><summary class="alg-sum">' + esc(t('practice_solution')) + '</summary>' + blocksHtml(fb.solution) + '</details>';
            }
            if (p.fbNote) html += '<p class="alg-fine alg-pr-note">' + esc(t(p.fbNote === 'up' ? 'practice_up' : 'practice_down')) + '</p>';
            // Третий промах подряд — возможно, не хватает основы темы.
            if (p.miss >= 3) html += prereqHtml(p.topic);
            html += '<div class="alg-actions" data-answer><button type="button" class="alg-btn" data-act="pr-next">' + esc(t('btn_next')) + '</button></div>';
            html += '</div>';
        }
        html += '</div>';
        render(html, 'practice');
        if (fresh) {
            reveal(panel.querySelector('.alg-pr'));
            var inp = document.getElementById('algAns');
            if (inp && !isTouch()) { try { inp.focus({ preventScroll: true }); } catch (_) {} }
            else if (!inp && kbd) {
                var first = panel.querySelector('.alg-opt');
                if (first) { try { first.focus({ preventScroll: true }); } catch (_) {} }
            }
            announce(p.name);
        } else if (p.fb) {
            var box = document.getElementById('algPfb');
            reveal(box);
            var nx = panel.querySelector('[data-act="pr-next"]');
            if (nx) { try { nx.focus({ preventScroll: true }); } catch (_) {} }
            announce(t(p.fb.correct ? 'practice_right' : (p.fb.skipped ? 'practice_shown' : 'practice_wrong')));
        }
    }

    function prCheck(skip) {
        var p = S.pr;
        if (!p || p.busy || p.fb || !p.item) return;
        var body = { ticket: p.ticket };
        var raw = null;
        if (skip) {
            body.skip = true;
        } else if (p.item.format === 'choice') {
            if (S.choice == null) { toast(t('choice_required'), 'warning'); return; }
            body.choice = S.choice;
        } else {
            var inp = document.getElementById('algAns');
            raw = inp ? inp.value : '';
            if (!validAnswer(p.item.format, raw)) {
                showInputError(inp, raw);
                return;
            }
            body.answer = raw.trim();
        }
        var choice = S.choice;
        var step = p.step;
        p.busy = true;
        panel.classList.add('alg-sending');
        api('POST', CFG.practiceCheckUrl, body).then(function (j) {
            p.busy = false;
            panel.classList.remove('alg-sending');
            if (S.pr !== p) return;
            if (!j.ok) {
                if (j.error === 'invalid') { showInputError(document.getElementById('algAns'), raw || 'x'); return; }
                if (j.error === 'ticket') { toast(t('practice_expired'), 'info'); loadPracticeItem(); return; }
                apiFail('practice_check', j);
                toast(t('net_error'));
                return;
            }
            p.n++;
            var note = null;
            if (j.correct) {
                p.ok++;
                p.streak++;
                p.miss = 0;
                if (p.streak > p.best) p.best = p.streak;
                if (p.step >= p.steps - 1) p.top++;
                if (p.streak % 2 === 0 && p.step < p.steps - 1) { p.step++; note = 'up'; }
            } else {
                p.streak = 0;
                p.top = 0;
                p.miss++;
                if (p.step > 0) { p.step--; note = 'down'; }
            }
            p.fb = j;
            p.fbNote = note;
            p.raw = raw;
            p.choice = choice;
            feat('practice_answer', { topic: p.topic, ok: j.correct ? 1 : 0, skip: skip ? 1 : 0, step: step, bug: j.bug ? j.bug.tag : null });
            renderPractice(false);
        }).catch(function () {
            p.busy = false;
            panel.classList.remove('alg-sending');
            apiFail('practice_check', null);
            toast(t('net_error'));
        });
    }

    /** Та же подсказка про запись числа, что у задания теста. */
    function showInputError(inp, raw) {
        var err = document.getElementById('algErr');
        if (err) { err.textContent = t(String(raw || '').trim() ? 'input_invalid' : 'input_empty'); err.hidden = false; }
        if (inp) {
            inp.setAttribute('aria-invalid', 'true');
            try { inp.focus(); } catch (_) {}
        }
    }

    function practiceReady(p) { return p.top >= 2 && p.ok >= 3; }

    function endPractice() {
        var p = S.pr;
        if (!p) return;
        var ready = practiceReady(p);
        feat('practice_end', { topic: p.topic, n: p.n, ok: p.ok, best: p.best, step: p.step, steps: p.steps, ready: ready ? 1 : 0 });
        if (!p.n) { leavePractice(); return; }
        var html = '<div class="alg-card alg-pr-sum">';
        html += '<div class="alg-eyebrow">' + esc(t('practice_summary_title')) + '</div>';
        html += '<h2 class="alg-h alg-pr-h">' + esc(p.name) + '</h2>';
        html += '<p class="alg-text">' + esc(t('practice_summary', { k: p.ok, n: p.n, s: p.best })) + '</p>';
        if (ready) {
            html += '<p class="alg-text alg-done">' + esc(t('practice_ready', { n: focusLen(1) })) + '</p>';
        } else {
            html += '<p class="alg-text">' + esc(t('practice_more')) + '</p>';
            if (p.ok / p.n < 0.4) html += prereqHtml(p.topic);
        }
        html += '<div class="alg-actions alg-ra">';
        if (ready) html += '<button type="button" class="alg-btn alg-ra-main" data-act="focus-one">' + esc(t('btn_focus_one')) + '</button>';
        html += '<button type="button" class="alg-btn' + (ready ? ' ghost' : '') + '" data-act="pr-more">' + esc(t('btn_practice_more')) + '</button>'
            + '<button type="button" class="alg-btn ghost" data-act="pr-back">' + esc(t('practice_back')) + '</button></div>';
        html += '</div>';
        render(html, 'practice_sum');
        reveal(panel.querySelector('.alg-pr-sum'));
        announce(t('practice_summary_title'));
    }

    function leavePractice() {
        var p = S.pr;
        S.pr = null;
        if (p && p.back === 'result' && S.result) {
            showResult(S.result, { back: true, topic: p.topic });
        } else {
            renderStart({ reveal: true });
        }
    }

    /* ── напоминание через месяц ─────────────────────────────────────── */

    function fmtDate(iso) {
        var d = new Date(iso);
        return isNaN(d) ? '' : d.toLocaleDateString(LOCALE, { day: 'numeric', month: 'long' });
    }

    function remindCardHtml() {
        return '<div class="alg-card alg-remind" id="algRemind"><h3 class="alg-h3">' + esc(t('remind_title')) + '</h3>'
            + '<p class="alg-fine">' + esc(t('remind_desc')) + '</p><div id="algRemindBody">' + remindBodyHtml() + '</div></div>';
    }

    function remindBodyHtml() {
        var st = S.remind;
        var cal = '<button type="button" class="alg-link" data-act="calendar">' + esc(t('btn_calendar')) + '</button>'
            + ' · <a class="alg-link" href="' + esc(gcalUrl()) + '" target="_blank" rel="noopener" data-act="gcal">' + esc(t('btn_gcal')) + '</a>';
        if (window.__AUTH_USER && CFG.remindUrl) {
            if (st && st.at) {
                return '<p class="alg-remind-on">' + esc(t('remind_on', { date: fmtDate(st.at), email: st.email || '' })) + '</p>'
                    + '<div class="alg-actions alg-remind-a"><button type="button" class="alg-btn ghost" data-act="remind-cancel">' + esc(t('btn_remind_cancel')) + '</button></div>'
                    + '<p class="alg-fine alg-cal">' + cal + '</p>';
            }
            return '<div class="alg-actions alg-remind-a"><button type="button" class="alg-btn" data-act="remind">' + esc(t('btn_remind')) + '</button></div>'
                + '<p class="alg-fine alg-cal">' + cal + '</p>';
        }
        return '<div class="alg-actions alg-remind-a"><button type="button" class="alg-btn" data-act="calendar">' + esc(t('btn_calendar')) + '</button>'
            + '<a class="alg-btn ghost" href="' + esc(gcalUrl()) + '" target="_blank" rel="noopener" data-act="gcal">' + esc(t('btn_gcal')) + '</a></div>'
            + (CFG.loginUrl ? '<p class="alg-fine">' + esc(t('remind_guest')) + ' <a class="alg-link" href="' + esc(loginHref()) + '" data-act="remind-login">' + esc(t('remind_login')) + '</a></p>' : '');
    }

    function redrawRemind() {
        var body = document.getElementById('algRemindBody');
        if (body) body.innerHTML = remindBodyHtml();
    }

    /** Вход с возвратом к этой же попытке (её ключ лежит в истории устройства). */
    function loginHref() {
        var back = (CFG.pagePath || location.pathname) + (S.run ? '?open=' + encodeURIComponent(S.run.id) : '');
        return CFG.loginUrl + (CFG.loginUrl.indexOf('?') === -1 ? '?' : '&') + 'redirect=' + encodeURIComponent(back);
    }

    function remindSet(on) {
        if (S.remindBusy || !CFG.remindUrl) return;
        if (on && !S.run) return;
        S.remindBusy = true;
        // Дословно то, что человек видел, — доказательство согласия на письмо.
        var body = on
            ? { run: S.run.id, token: S.run.token, wording: t('remind_title') + ' ' + t('remind_desc') + ' [' + t('btn_remind') + ']' }
            : { cancel: true };
        api('POST', CFG.remindUrl, body).then(function (j) {
            S.remindBusy = false;
            if (j.ok) {
                S.remind = j.remind || null;
                feat('remind', { on: on ? 1 : 0 });
                redrawRemind();
                if (on && S.remind) announce(t('remind_on', { date: fmtDate(S.remind.at), email: S.remind.email || '' }));
                else toast(t('remind_off'), 'info');
                return;
            }
            if (j.error === 'no_email') { feat('remind', { on: 1, err: 'no_email' }); toast(t('remind_no_email'), 'warning'); return; }
            if (j.__status === 401) { location.href = loginHref(); return; }
            apiFail('remind', j);
            toast(t('net_error'));
        }).catch(function () { S.remindBusy = false; apiFail('remind', null); toast(t('net_error')); });
    }

    function remindDate() {
        var d = new Date(Date.now() + 30 * 86400000);
        return d;
    }

    function ymd(d) {
        var p = function (n) { return (n < 10 ? '0' : '') + n; };
        return d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate());
    }

    function calendarText() {
        var r = S.result && S.result.result;
        var url = (CFG.shareUrl || location.href.split('?')[0]) + '?from=calendar';
        return { title: t('calendar_title'), desc: t('calendar_desc', { score: r && r.score != null ? r.score : '—', url: url }), url: url };
    }

    function gcalUrl() {
        var d = remindDate();
        var end = new Date(d.getTime() + 86400000);
        var c = calendarText();
        return 'https://calendar.google.com/calendar/render?action=TEMPLATE&text=' + encodeURIComponent(c.title)
            + '&dates=' + ymd(d) + '/' + ymd(end) + '&details=' + encodeURIComponent(c.desc);
    }

    /** Строка iCalendar: экранирование и перенос по 75 октетов (RFC 5545). */
    function icsEsc(s) { return String(s).replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\r?\n/g, '\\n'); }
    function icsFold(line) {
        var enc = window.TextEncoder ? new TextEncoder() : null;
        if (!enc) return line;
        var out = [], cur = '', bytes = 0;
        Array.from(line).forEach(function (ch) {
            var b = enc.encode(ch).length;
            if (bytes + b > 73) { out.push(cur); cur = ' '; bytes = 1; }
            cur += ch;
            bytes += b;
        });
        out.push(cur);
        return out.join('\r\n');
    }

    function downloadCalendar() {
        var d = remindDate();
        var end = new Date(d.getTime() + 86400000);
        var c = calendarText();
        var now = new Date();
        var stamp = now.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
        var lines = [
            'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//' + location.hostname + '//algebra-test//EN', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH',
            'BEGIN:VEVENT',
            'UID:algebra-' + (S.run ? S.run.id : 'x') + '-' + now.getTime() + '@' + location.hostname,
            'DTSTAMP:' + stamp,
            'DTSTART;VALUE=DATE:' + ymd(d),
            'DTEND;VALUE=DATE:' + ymd(end),
            'SUMMARY:' + icsEsc(c.title),
            'DESCRIPTION:' + icsEsc(c.desc),
            'URL:' + c.url,
            'BEGIN:VALARM', 'ACTION:DISPLAY', 'DESCRIPTION:' + icsEsc(c.title), 'TRIGGER:PT9H', 'END:VALARM',
            'END:VEVENT', 'END:VCALENDAR'
        ];
        var text = lines.map(icsFold).join('\r\n') + '\r\n';
        var blob = new Blob([text], { type: 'text/calendar;charset=utf-8' });
        feat('calendar', { kind: 'ics' });
        var ok = true;
        try {
            if (window.__downloadFile) ok = window.__downloadFile(blob, 'algebra-test-reminder.ics') !== false;
        } catch (_) { ok = false; }
        if (ok) toast(t('calendar_saved'), 'success');
    }

    function share() {
        var r = S.result && S.result.result;
        if (!r) return;
        var g = r.level && r.level.grade;
        var mm = masteredPair(r);
        var text = t('share_text', { level: g ? gradeLabel(Math.min(g, 11)) : '—', m: mm[0], n: mm[1] });
        var url = CFG.shareUrl || location.href.split('?')[0];
        feat('share', {});
        if (navigator.share) {
            navigator.share({ text: text, url: url }).catch(function () {});
            return;
        }
        copyText(text + ' ' + url, t('share_copied'), null);
    }

    /**
     * Ссылка на этот результат — родителю, репетитору, учителю. Несёт ключ
     * прогона: кто её получил, видит результат и может купить к нему разбор,
     * но не продолжает чужой тест (кнопок продолжения на такой странице нет).
     */
    function resultLink() {
        if (!S.run) return;
        var base = CFG.shareUrl || location.href.split('?')[0];
        var url = base + (base.indexOf('?') === -1 ? '?' : '&') + 'r=' + encodeURIComponent(S.run.id) + '&k=' + encodeURIComponent(S.run.token);
        if (isTouch() && navigator.share) {
            feat('result_link', { via: 'share' });
            navigator.share({ title: t('result_link_text'), text: t('result_link_text'), url: url }).catch(function () {});
            return;
        }
        copyText(url, t('result_link_copied'), url);
    }

    /** Копирование с честным запасным путём: нет буфера обмена — поле со
     *  ссылкой, выделенное целиком (скопировать вручную). */
    function copyText(text, okMsg, boxValue) {
        var box = document.getElementById('algLinkBox');
        var inp = document.getElementById('algLinkIn');
        var showBox = function (via) {
            if (boxValue != null) feat('result_link', { via: via });
            if (!box || !inp) return;
            inp.value = boxValue != null ? boxValue : text;
            box.hidden = false;
            try { inp.focus({ preventScroll: true }); inp.select(); } catch (_) {}
            reveal(box);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(function () {
                toast(okMsg, 'success');
                if (boxValue != null) { feat('result_link', { via: 'clipboard' }); if (box && inp) { inp.value = boxValue; box.hidden = false; } }
            }, function () { showBox('box'); });
        } else {
            showBox('box');
        }
    }

    /** Результат по ссылке: только просмотр. */
    function openShared(id, token) {
        S.shared = true;
        S.run = { id: id, token: token };
        renderComputing(t('loading'));
        api('GET', '/api/algebra-test/state?run=' + encodeURIComponent(id) + '&token=' + encodeURIComponent(token)).then(function (j) {
            if (j.ok && j.status === 'done' && j.data) { showResult(j.data); return; }
            feat('shared_view', { ok: 0, status: j.__status || 0, st: j.status || '' });
            leaveShared();
            toast(t(j.ok ? 'shared_unfinished' : 'shared_gone'), 'warning');
            renderStart({ reveal: true });
        }).catch(function () { apiFail('shared', null); leaveShared(); toast(t('net_error')); renderStart({ reveal: true }); });
    }

    function leaveShared() {
        S.shared = false;
        S.run = null;
        S.result = null;
        try {
            var u = new URL(location.href);
            u.searchParams.delete('r');
            u.searchParams.delete('k');
            history.replaceState({}, '', u.pathname + (u.search || '') + u.hash);
        } catch (_) {}
    }

    /* ── события ────────────────────────────────────────────────────── */

    panel.addEventListener('click', function (e) {
        var el = e.target.closest('[data-act],[data-level],[data-goal],[data-mode],[data-choice],[data-key]');
        if (!el || !panel.contains(el)) return;
        press(el);
    });

    /** Нажатие на элемент панели — живое или донесённое __earlyAction. */
    function press(el) {
        if (el.hasAttribute('data-level')) {
            S.level = +el.getAttribute('data-level');
            S.needGrade = false;
            if (S.goal !== 'gaps') {
                var ok = (S.goal === 'oge' && S.level >= 8 && S.level <= 9) || (S.goal !== 'oge' && S.level >= 10);
                if (!ok) S.goal = 'gaps';
            }
            try { if (window.__toolSettings) window.__toolSettings.save(SLUG, 'level', S.level); } catch (_) {}
            feat('grade', { level: S.level });
            renderStart({ focus: '[data-level="' + S.level + '"]' });
            return;
        }
        if (el.hasAttribute('data-goal')) {
            S.goal = el.getAttribute('data-goal');
            feat('goal', { goal: S.goal });
            renderStart({ focus: '[data-goal="' + S.goal + '"]' });
            return;
        }
        if (el.hasAttribute('data-mode')) {
            S.mode0 = el.getAttribute('data-mode');
            try { if (window.__toolSettings) window.__toolSettings.save(SLUG, 'mode', S.mode0); } catch (_) {}
            feat('mode', { mode: S.mode0 });
            renderStart({ focus: '[data-mode="' + S.mode0 + '"]' });
            return;
        }
        if (el.hasAttribute('data-choice')) {
            S.choice = +el.getAttribute('data-choice');
            panel.querySelectorAll('.alg-opt').forEach(function (b) {
                var on = +b.getAttribute('data-choice') === S.choice;
                b.classList.toggle('on', on);
                b.setAttribute('aria-checked', on ? 'true' : 'false');
            });
            return;
        }
        if (el.hasAttribute('data-key')) {
            var inp = document.getElementById('algAns');
            if (!inp) return;
            var k = el.getAttribute('data-key');
            if (k === '∅') {
                inp.value = '∅';
                if (S.screen === 'practice') prCheck(false); else submit(false);
                return;
            }
            var s = inp.selectionStart != null ? inp.selectionStart : inp.value.length;
            var en = inp.selectionEnd != null ? inp.selectionEnd : s;
            var ins = k === ';' ? '; ' : k;
            inp.value = inp.value.slice(0, s) + ins + inp.value.slice(en);
            try { inp.setSelectionRange(s + ins.length, s + ins.length); } catch (_) {}
            var err0 = document.getElementById('algErr');
            if (err0) err0.hidden = true;
            if (!isTouch()) inp.focus();
            return;
        }
        var act = el.getAttribute('data-act');
        if (act === 'start') {
            if (S.level == null) {
                // Сначала класс: от него зависят темы. Показать, ЧЕГО не хватает,
                // а не молча не реагировать.
                S.needGrade = true;
                feat('start_no_grade', {});
                renderStart({ focus: '[data-level]' });
                var step = document.getElementById('algStepGrade');
                reveal(step);
                return;
            }
            startRun({ level: S.level, goal: S.goal, mode: S.mode0 });
        } else if (act === 'class-start') {
            var nm = (document.getElementById('algName') || {}).value || '';
            nm = nm.trim();
            if (!nm) { toast(t('name_required'), 'warning'); var ni = document.getElementById('algName'); if (ni) ni.focus(); return; }
            store('alg_student_name', nm);
            feat('class_join', {});
            startRun({ class: S.clsCode, name: nm });
        } else if (act === 'answer') {
            submit(false);
        } else if (act === 'skip') {
            submit(true);
        } else if (act === 'finish') {
            finishEarly();
        } else if (act === 'resume') {
            resume(load(ACTIVE_KEY), 'resume');
        } else if (act === 'discard') {
            feat('resume_discard', {});
            store(ACTIVE_KEY, null);
            renderStart({ focus: '[data-act="start"]' });
        } else if (act === 'retake') {
            feat('retake', {});
            S.run = null;
            S.result = null;
            if (window.AlgReport) try { window.AlgReport.unmount(); } catch (_) {}
            if (S.clsCode && S.cls && S.cls.ok) renderClassJoin(); else renderStart({ reveal: true });
        } else if (act === 'try-self') {
            feat('shared_try_self', {});
            if (window.AlgReport) try { window.AlgReport.unmount(); } catch (_) {}
            leaveShared();
            renderStart({ reveal: true });
        } else if (act === 'upgrade') {
            upgrade();
        } else if (act === 'share') {
            share();
        } else if (act === 'result-link') {
            resultLink();
        } else if (act === 'solo') {
            S.clsCode = null;
            renderStart({ reveal: true });
        } else if (act === 'open-history') {
            var id = +el.getAttribute('data-run');
            var rec = historyList().filter(function (x) { return x.run === id; })[0];
            if (rec) {
                feat('history_open', { src: rec.acct ? 'acct' : 'local' });
                resume(rec, 'history');
            }
        } else if (act === 'teacher') {
            feat('teacher_click', { where: el.getAttribute('data-where') || '' });
        } else if (act === 'exam-calc') {
            feat('exam_calc', {});
        } else if (act === 'practice') {
            openPractice(el.getAttribute('data-topic'), el.getAttribute('data-from') || '');
        } else if (act === 'pr-check') {
            prCheck(false);
        } else if (act === 'pr-skip') {
            prCheck(true);
        } else if (act === 'pr-next' || act === 'pr-more') {
            if (!S.pr) return;
            if (act === 'pr-more') renderComputing(t('practice_loading'));
            loadPracticeItem();
        } else if (act === 'practice-end') {
            endPractice();
        } else if (act === 'pr-back') {
            leavePractice();
        } else if (act === 'focus') {
            startFocus((el.getAttribute('data-topics') || '').split(',').filter(Boolean), el.getAttribute('data-from') || '');
        } else if (act === 'focus-one') {
            if (S.pr) startFocus([S.pr.topic], 'practice');
        } else if (act === 'remind') {
            remindSet(true);
        } else if (act === 'remind-cancel') {
            remindSet(false);
        } else if (act === 'calendar') {
            downloadCalendar();
        } else if (act === 'gcal') {
            feat('calendar', { kind: 'gcal' });
        } else if (act === 'remind-login') {
            feat('remind_login', {});
        }
    }

    // Печать результата (родителю, учителю): свёрнутые разделы раскрываются
    // на время печати и сворачиваются обратно.
    var printOpened = [];
    window.addEventListener('beforeprint', function () {
        printOpened = [];
        S.printing = true;
        panel.querySelectorAll('details:not([open])').forEach(function (d) { d.open = true; printOpened.push(d); });
        feat('print', { screen: S.screen });
    });
    window.addEventListener('afterprint', function () {
        printOpened.forEach(function (d) { d.open = false; });
        printOpened = [];
        setTimeout(function () { S.printing = false; }, 0);
    });

    // Какие разделы результата открывают — по одному событию на раздел.
    panel.addEventListener('toggle', function (e) {
        var d = e.target;
        if (S.printing || !d || !d.open || !d.getAttribute) return;
        var what = d.getAttribute('data-open');
        if (!what || S.opened[what]) return;
        S.opened[what] = 1;
        feat('open', { what: what });
    }, true);

    panel.addEventListener('keydown', function (e) {
        if (S.screen === 'class' && e.key === 'Enter' && e.target && e.target.id === 'algName') {
            e.preventDefault();
            var b = panel.querySelector('[data-act="class-start"]');
            if (b) b.click();
            return;
        }
        // Задание теста или тренировки — одинаковая клавиатура: Enter отвечает,
        // цифры 1–4 выбирают вариант. В тренировке после проверки Enter ведёт
        // к следующему заданию.
        var cur = currentItem();
        if (!cur) return;
        if (e.key === 'Enter' && !e.shiftKey) {
            var tg = e.target;
            // Enter на кнопке — её собственное действие (на «Не знаю» — пропуск,
            // а не «Ответить», как было). Вариант ответа — исключение: Enter на
            // нём выбирает его и отвечает.
            if (tg && (tg.tagName === 'A' || (tg.tagName === 'BUTTON' && !tg.classList.contains('alg-opt')))) return;
            e.preventDefault();
            if (cur.done) { loadPracticeItem(); return; }
            if (tg && tg.classList && tg.classList.contains('alg-opt')) tg.click();
            if (cur.practice) prCheck(false); else submit(false);
            return;
        }
        if (!cur.done && cur.item.format === 'choice' && /^[1-4]$/.test(e.key) && !(e.target && e.target.tagName === 'INPUT')) {
            var b2 = panel.querySelector('.alg-opt[data-choice="' + (+e.key - 1) + '"]');
            if (b2) b2.click();
        }
    });
    document.addEventListener('keydown', function (e) {
        if (e.defaultPrevented) return;   // уже обработано панелью
        var cur = currentItem();
        if (!cur || cur.item.format !== 'choice') return;
        if (e.target && (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.tagName === 'SELECT')) return;
        if (e.target && e.target.closest && e.target.closest('#algPanel')) return;   // панель решила сама
        if (/^[1-4]$/.test(e.key) && !cur.done) {
            var b = panel.querySelector('.alg-opt[data-choice="' + (+e.key - 1) + '"]');
            if (b) { b.click(); e.preventDefault(); }
        } else if (e.key === 'Enter' && !(e.target && (e.target.tagName === 'BUTTON' || e.target.tagName === 'A'))) {
            if (cur.done) loadPracticeItem();
            else if (cur.practice) prCheck(false);
            else submit(false);
            e.preventDefault();
        }
    });

    /** Задание на экране: {item, practice, done} или null. */
    function currentItem() {
        if (S.screen === 'question' && S.item) return { item: S.item, practice: false, done: false };
        if (S.screen === 'practice' && S.pr && S.pr.item) return { item: S.pr.item, practice: true, done: !!S.pr.fb };
        return null;
    }
    panel.addEventListener('input', function (e) {
        if (e.target && e.target.id === 'algAns') {
            var err = document.getElementById('algErr');
            if (err) err.hidden = true;
            e.target.removeAttribute('aria-invalid');
        }
    });

    /* ── старт ──────────────────────────────────────────────────────── */

    function boot() {
        try {
            if (window.__toolSettings) {
                var lv = window.__toolSettings.load(SLUG, 'level', null);
                var md = window.__toolSettings.load(SLUG, 'mode', null);
                if (lv != null && (CFG.levels || []).indexOf(+lv) >= 0) S.level = +lv;
                if (md === 'quick' || md === 'full') S.mode0 = md;
            }
        } catch (_) {}
        var params = new URLSearchParams(location.search);
        var from = params.get('from');
        // Пришли по письму или из календаря «пройдите снова через месяц».
        if (from === 'remind' || from === 'calendar') feat('remind_open', { via: from });
        var sid = parseInt(params.get('r') || '', 10);
        var skey = params.get('k') || '';
        if (sid > 0 && /^[0-9a-f]{16,80}$/i.test(skey)) {
            openShared(sid, skey);
            claimEarly(false);
            return;
        }
        // Вернулись со входа («Войдите — и мы напомним письмом»): открыть ту же
        // попытку, если её ключ есть в истории этого устройства.
        var openId = parseInt(params.get('open') || '', 10);
        if (openId > 0) {
            try {
                var u = new URL(location.href);
                u.searchParams.delete('open');
                history.replaceState({}, '', u.pathname + (u.search || '') + u.hash);
            } catch (_) {}
            var rec = historyList().filter(function (x) { return x.run === openId && x.token; })[0];
            if (rec) {
                feat('login_return', {});
                resume(rec, 'history');
                claimEarly(false);
                return;
            }
        }
        var code = params.get('class');
        if (code && CFG.classEnabled) {
            S.clsCode = code.toUpperCase();
            renderComputing(t('loading'));
            api('GET', '/api/algebra-test/class?code=' + encodeURIComponent(S.clsCode)).then(function (j) {
                S.cls = j;
                if (j.ok) S.lastClassInfo = j;
                else apiFail('class', j);
                renderClassJoin();
            }).catch(function () { S.cls = { ok: false, error: 'net_error' }; renderClassJoin(); });
            claimEarly(false);
            return;
        }
        renderStart();
        // Незаконченный тест на первом экране — карточка «Продолжить»; нажатие
        // «Начать» до скрипта её не видело, и повторять его нельзя.
        var act0 = load(ACTIVE_KEY);
        claimEarly(!!startNode && !(act0 && act0.run));
    }

    window.AlgApp = { state: S, t: t, richText: richText, texHtml: texHtml };

    // Вошедшему — история и с других устройств. Сессия приезжает отдельным
    // запросом (страница может быть из кэша), поэтому слушаем и событие.
    window.addEventListener('auth-ready', function () {
        mergeServerHistory();
        // Карточка напоминания нарисована до того, как стало известно о входе.
        if (S.screen === 'result') redrawRemind();
    });
    if (window.__AUTH_USER) setTimeout(mergeServerHistory, 0);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
})();
